import { render, staticRenderFns } from "./ShowsList.vue?vue&type=template&id=77691e31"
import script from "./ShowsList.vue?vue&type=script&lang=ts"
export * from "./ShowsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports